import { Routes } from '@angular/router';
import { authGuard } from './auth/guards/auth.guard';
import { LoginComponent } from './auth/components/login/login.component';
import { ChoosePhoneNumberComponent } from './auth/components/choose-phone-number/choose-phone-number.component';
import { EmployeeImportComponent } from './employees/components/employee-import/employee-import.component';
import { WeeklyTimesheetComponent } from './timesheets/components//weekly-timesheet/weekly-timesheet.component';
import { DailyPunchesComponent } from './timesheets/components/daily-punches/daily-punches.component';
import { EmployeeListComponent } from './employees/components/employee-list/employee-list.component';
import { EmployeeProfileComponent } from './employees/components/employee-profile/employee-profile.component';
import { CompaniesComponent } from './settings/application-config/companies/companies.component';
import { DepartmentsComponent } from './settings/application-config/departments/departments.component';
import { WorkerTypesComponent } from './settings/application-config/worker-types/worker-types.component';
import { PayGroupsComponent } from './settings/application-config/pay-groups/pay-groups.component';
import { WorkOrdersComponent } from './settings/planning/work-orders/work-order-numbers.component';
import { ProjectsComponent } from './settings/planning/projects/projects.component';
import { WeeklyCalendarComponent } from './settings/planning/weekly-calendar/weekly-calendar.component';
import { CompanyImportComponent } from './settings/application-config/companies/companies-import/company-import.component';
import { DepartmentImportComponent } from './settings/application-config/departments/departments-import/department-import.component';
import { WorkerTypeImportComponent } from './settings/application-config/worker-types/worker-types-import/worker-type-import.component';
import { WorkOrderImportComponent } from './settings/planning/work-orders/work-orders-import/work-order-import.component';
import { AdminTimesheetComponent } from './timesheets/components/admin-timesheet/admin-timesheet.component';
import { AdminTimesheetOverviewComponent } from './timesheets/components/multi-week/admin-timesheet-overview.component';
import { WorkOrdersAssignComponent } from './settings/planning/work-orders/work-orders-assign/work-orders-assign.component';
import { HoursComponent } from './hours/components/hours.component';
import { OfftimeComponent } from './offtime/offtime.component';
import { ScheduleGroupsComponent } from './scheduling/components/schedule-groups/schedule-groups.component';
import { SchedulingSyncComponent } from './scheduling/components/scheduling-sync/scheduling-sync.component';
import { UserAssignSchedulesComponent } from './scheduling/components/user-assign-schedules/user-assign-schedules.component';
import { HolidayComponent } from './settings/application-config/holiday/holiday.component';
import { EmployeeMissingDataComponent } from './employees/components/employee-missing-data/employee-missing-data.component';
import { PunchHistoryComponent } from './timesheets/components/punch-history/punch-history.component';
import { RoundingRulesComponent } from './settings/application-config/rounding-rules/rounding-rules.component';
import { SetNewPasswordComponent } from './auth/components/set-new-password/set-new-password.component';
import { VerifyNewAccountComponent } from './auth/components/verify-new-account/verify-new-account.component';
import { NewAccountSetupComponent } from './auth/components/new-account-setup/new-account-setup.component';
import { LoginVia2FAComponent } from './auth/components/login-via-2fa/login-via-2fa.component';
import { ClockControlComponent } from './settings/device-management/clock-control/clock-control.component';
import { ShiftsComponent } from './settings/application-config/shifts/shifts.component';
import { ChangePasswordComponent } from './auth/components/change-password/change-password.component';
import { ViolationsComponent } from './timesheets/components/violations/violations.component';
import { YywwComponent } from './settings/planning/yyww/yyww.component';
import { ResetPasswordComponent } from './auth/components/reset-password/reset-password.component';
import { ResetPasswordRequestComponent } from './auth/components/reset-password-request/reset-password-request.component';
import { LeavePoliciesComponent } from './settings/accruals/policies/leave-policies.component';
import { LeavePolicyDetailComponent } from './settings/accruals/policies/policy-details/leave-policy-detail.component';
import { LeaveTransactionsComponent } from './settings/accruals/transactions/leave-transactions.component';
import { LeavePolicyHistoryComponent } from './settings/accruals/policy-history/leave-policy-history.component';
import { EmployeeLeaveBalancesComponent } from './settings/accruals/employee-balances/employee-leave-balances.component';
import { EmployeeLeaveDetailComponent } from './settings/accruals/employee-balances/employee-details/employee-leave-detail.component';
import { PayrollSyncComponent } from './settings/payroll/payroll-sync/payroll-sync.component';
import { PayrollSyncHistoryComponent } from './settings/payroll/payroll-sync-history/payroll-sync-history.component';
import { PayrollUnapprovedTimesheetsComponent } from './settings/payroll/unapproved-timesheets/payroll-unapproved-timesheets.component';
import { PayrollBookedHoursHistoryComponent } from './settings/payroll/booked-hour-history/payroll-booked-hours-history.component';
import { PayableHoursHistoryComponent } from './settings/payroll/payable-hours-history/payable-hours-history.component';
import { NotificationsPageComponent } from './shared/notifications/notifications-page/notifications-page.component';
import { PayableHoursReportComponent } from './reports/payable-hours/payable-hours-report.component';
import { PayCodesComponent } from './settings/application-config/pay-codes/pay-codes.component';

export const appRoutes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'choose-phone-number', component: ChoosePhoneNumberComponent },
  {
    path: 'verify-2fa',
    component: LoginVia2FAComponent,
  },
  {
    path: 'new-account-setup',
    component: NewAccountSetupComponent,
  },
  {
    path: 'verify-new-account',
    component: VerifyNewAccountComponent,
  },
  {
    path: 'set-new-password',
    component: SetNewPasswordComponent,
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  {
    path: 'reset-password-request',
    component: ResetPasswordRequestComponent,
  },
  {
    path: 'hours',
    component: HoursComponent,
    canActivate: [authGuard],
  },

  {
    path: 'offtime',
    component: OfftimeComponent,
    canActivate: [authGuard],
  },
  {
    path: 'notifications',
    redirectTo: 'notifications/time-off',
    pathMatch: 'full',
  },
  {
    path: 'notifications/time-off',
    component: NotificationsPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'notifications/supervisor-hours',
    component: NotificationsPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'notifications/my-hours',
    component: NotificationsPageComponent,
    canActivate: [authGuard],
  },

  // Employees main page (list)
  {
    path: 'employees',
    component: EmployeeListComponent,
    canActivate: [authGuard],
  },
  {
    path: 'employees/missing-info',
    component: EmployeeMissingDataComponent,
    canActivate: [authGuard],
  },
  {
    path: 'employees/import',
    component: EmployeeImportComponent,
    canActivate: [authGuard],
  },
  {
    path: 'employees/:id',
    component: EmployeeProfileComponent,
    canActivate: [authGuard],
  },

  // Timesheets
  {
    path: 'timesheets',
    canActivate: [authGuard],
    children: [
      { path: '', component: WeeklyTimesheetComponent }, // default weekly view
      { path: 'daily-punches', component: DailyPunchesComponent },
      { path: 'admin', component: AdminTimesheetOverviewComponent },
      { path: 'admin/:userId/:yyyyww', component: AdminTimesheetComponent },
      { path: 'punch-history', component: PunchHistoryComponent },
      { path: 'violations', component: ViolationsComponent },
    ],
  },

  // Settings / Application Configuration
  {
    path: 'settings',
    canActivate: [authGuard],
    children: [
      {
        path: 'application',
        children: [
          { path: '', redirectTo: 'companies', pathMatch: 'full' },
          { path: 'companies', component: CompaniesComponent },
          { path: 'companies/import', component: CompanyImportComponent },
          { path: 'departments', component: DepartmentsComponent },
          { path: 'departments/import', component: DepartmentImportComponent },
          { path: 'shifts', component: ShiftsComponent },
          { path: 'workertypes', component: WorkerTypesComponent },
          { path: 'workertypes/import', component: WorkerTypeImportComponent },
          { path: 'paygroups', component: PayGroupsComponent },
          { path: 'rounding-rules', component: RoundingRulesComponent },
          { path: 'holidays', component: HolidayComponent },
          { path: 'pay-codes', component: PayCodesComponent },
        ],
      },
      {
        path: 'planning',
        canActivate: [authGuard],
        children: [
          { path: '', redirectTo: 'work-orders', pathMatch: 'full' },
          { path: 'work-orders', component: WorkOrdersComponent },
          { path: 'work-orders/import', component: WorkOrderImportComponent },
          { path: 'work-orders/assign', component: WorkOrdersAssignComponent },
          { path: 'projects', component: ProjectsComponent },
          { path: 'yyww', component: YywwComponent },
          { path: 'weekly-calendar', component: WeeklyCalendarComponent },
        ],
      },
      {
        path: 'accruals',
        canActivate: [authGuard],
        children: [
          { path: '', redirectTo: 'accruals/policies', pathMatch: 'full' },
          { path: 'policies', component: LeavePoliciesComponent },
          { path: 'policies/:id', component: LeavePolicyDetailComponent },
          { path: 'leave-transactions', component: LeaveTransactionsComponent },
          { path: 'policy-history', component: LeavePolicyHistoryComponent },
          { path: 'employee-leave-balances', component: EmployeeLeaveBalancesComponent },
          { path: 'employee-leave-balances/:id', component: EmployeeLeaveDetailComponent },

        ],
      },
      {
        path: 'payroll',
        canActivate: [authGuard],
        children: [
          { path: '', redirectTo: 'payroll-sync', pathMatch: 'full' },
          { path: 'payroll-sync', component: PayrollSyncComponent },
          { path: 'payroll-sync-history', component: PayrollSyncHistoryComponent },
          { path: 'unapproved-timesheets', component: PayrollUnapprovedTimesheetsComponent },
          { path: 'booked-hours-history', component: PayrollBookedHoursHistoryComponent },
          { path: 'payable-hours-history', component: PayableHoursHistoryComponent },
        ],
      },
      {
        path: 'device-management',
        canActivate: [authGuard],
        children: [
          { path: '', redirectTo: 'clock-control', pathMatch: 'full' },
          { path: 'clock-control', component: ClockControlComponent },
        ],
      },
      {
        path: 'reports',
        canActivate: [authGuard],
        children: [
          { path: '', redirectTo: 'payable-hours-report', pathMatch: 'full' },
          { path: 'payable-hours-report', component: PayableHoursReportComponent },
        ],
      },
    ],
  },

  {
    path: 'scheduling',
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'schedule-groups', pathMatch: 'full' },
      { path: 'schedule-groups', component: ScheduleGroupsComponent },
      { path: 'scheduling-sync', component: SchedulingSyncComponent },
      { path: 'user-assign-schedules', component: UserAssignSchedulesComponent },
    ],
  },

  // Default route
  { path: '', redirectTo: 'hours', pathMatch: 'full' },

  // Fallback
  { path: '**', redirectTo: 'hours' },
];
